import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import VideoPreview from '../../core/components/videoPreview';
import { inject } from 'mobx-react';
import HttpClient from 'services/HttpClient';
import _ from 'lodash';
import moment from 'moment';
const DASHBOARD_REQUEST = '/api/v1/dashboards';
const EVENTBRITE_REQUEST = '/api/v1/events';
const COURSE_REQUEST = '/api/v1/courses';

@inject('userStore')
@inject('courseStore')
@inject('createCourseStore')

export default class Base extends Component {

  state = {
    tutorials: [],
    eventbrite: [],
    title: ''
  };

  componentWillMount() {
    new HttpClient().get(DASHBOARD_REQUEST).then(response => {
      const {days_last_visit, logged_times, registration_date, tutorials} = response.body.data;
      this.setState({
        ...this.state,
        days_last_visit: days_last_visit,
        logged_times: logged_times,
        registration_date: registration_date,
        tutorials: tutorials
      })
    });
    new HttpClient().get(EVENTBRITE_REQUEST).then(response => {
      let liveEvents = response.body.events.filter(event => {
        return event.attrs.attrs.status === 'live'
      });
      liveEvents = liveEvents.map(event => {
        return event = event.attrs.attrs
      })
      this.setState({
        ...this.state,
        eventbrite: liveEvents
      })
    });
    new HttpClient().get(COURSE_REQUEST).then(response => {
      // const now = new Date().setHours(0,0,0,0);
      let closest = {};
      let subscribedCount = 0;
      let title = 'Courses';

      response.body.data.courses.forEach(course => {
        // const on_site_date = new Date(course.on_site_date).setHours(0,0,0,0);
        const off_site_date = new Date(course.off_site_date).setHours(0,0,0,0);
        if(course.is_purchased)
          subscribedCount =+ 1;

        if(closest.on_site_date) {
          if(off_site_date > closest.off_site_date) {
            closest = course;
          }
        } else {
          closest = course;
        }
      });

      title = subscribedCount >= 2 ? 'Courses' : title;

      this.setState({ title })
      this.props.courseStore.setCourses(response.body.data.courses);
      this.props.courseStore.setCourse(closest);
    })
  }

  getTime = seconds => {
    let hours = parseInt(seconds / (60 * 60));
    let minutes = parseInt(((seconds - hours * 60 * 60) / 60));
    seconds = seconds - minutes * 60 - hours * 60 * 60;
    return `${hours}:${minutes}:${seconds}`
  };

  showEvents = () => {
    return this.state.eventbrite.map((event, idx) => {
      return (
        <div className="eventbrite-widg" key={idx}>
          <h3>{event.name.text}</h3>
          <span className="date">{moment(event.start.utc).format('MMM Do YY, h:mm a')} - {moment(event.end.utc).format('MMM Do YY, h:mm a')}</span>
          <p className="desc">{event.summary}</p>
          <a href={event.url} target='_blank'><button>Event details</button></a>
        </div>
      )
    })
  }

  onCourseDetails = () => {
    const { courseStore: { closestCourse }, createCourseStore: { setCourse } } = this.props;

    setCourse(closestCourse);
  }

  render() {
    const { closestCourse } = this.props.courseStore;
    // const { title } = this.state;
    const videoItem = this.state.tutorials.map((item, index) => {
      return (
        <div className="col-10 col-md-3"
          key={index}>
          <Link to={`/tutorial/${item.slug}`}>
            <VideoPreview
              slug={item.slug}
              placeholder={{ img: item.thumbnail_url }}
              title={item.title}
              time={this.getTime(item.duration_time)}
              type={{ url: `/categories/?slug=${item.category_slug}`, name: item.category_title }}
              viewed={item.viewed} />
          </Link>
        </div>
      )
    });

    return (
      <div className="dashboard-container">
        <div className="dashboard-header">
          <div className="dashboard-header-inner">
            <div className="container-fluid">
              <div className="row justify-content-center dashboard-content-container">
                <div className="col-10 col-md-3"></div>
                <div className="col-10 col-md-6 main-container">
                  <h1 className="dashboard-title">WELCOME TO PRESCRIPTION REVISION</h1>
                  <div className="dashboard-user-info">
                    <p className="name">{this.props.userStore.full_name()}</p>
                    <p className="mail">{this.props.userStore.user.email}</p>
                  </div>
                  <div className="dashboard-visit-info">
                    <div className="dashboard-visit-part">
                      <p className="title">{this.state.logged_times}</p>
                      <p className="caption">Number of Logins</p>
                    </div>
                    <div className="dashboard-visit-part">
                      <p className="title">{this.state.registration_date}</p>
                      <p className="caption">Registration Date</p>
                    </div>
                    <div className="dashboard-visit-part">
                      <p className="title">{this.state.days_last_visit}</p>
                      <p className="caption">Last login</p>
                    </div>
                  </div>
                  <h3 className="dashboard-caption">Ready To Take The Course?</h3>
                  <div className="dashboard-btn-holder">
                    <Link onClick={ this.onCourseDetails } to="/categories">
                      <div
                        className="btn blue rounded icons"
                        style={{
                          textOverflow: 'ellipsis',
                          overflow: 'hidden'
                        }}
                      >
                        <span><i className="ic ic-play " />{ closestCourse.title }</span>
                      </div>
                    </Link>
                    <Link to="/personal-tracker">
                      <div className="btn blue rounded icons">
                        <span><i className="ic ic-diagram" />CPD TRACKER</span>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="col-10 col-md-3 events-container events-autenticated-container">
                  {!_.isEmpty(this.state.eventbrite) && this.showEvents()}
                </div>
              </div>
            </div>
          </div>
        </div>
        {_.isEmpty(this.state.tutorials) ||
          <div className="dashboard-watched">
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-10">
                  <h2 className="dashboard-watched-title">You Recently Watched:</h2>
                </div>
              </div>
              <div className="row justify-content-center">
                {videoItem}
              </div>
            </div>
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/containers/Base.js